import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/shared/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {



  countries: ICountries[] = [
    { countryName: "Afghanistan", phoneCode: "+93", shortName: "AF", phoneLength: 9 },
    { countryName: "Albania", phoneCode: "+355", shortName: "AL", phoneLength: 9 },
    { countryName: "Algeria", phoneCode: "+213", shortName: "DZ", phoneLength: 9 },
    { countryName: "Andorra", phoneCode: "+376", shortName: "AD", phoneLength: 6 },
    { countryName: "Angola", phoneCode: "+244", shortName: "AO", phoneLength: 9 },
    { countryName: "Antigua and Barbuda", phoneCode: "+1-268", shortName: "AG", phoneLength: 7 },
    { countryName: "Argentina", phoneCode: "+54", shortName: "AR", phoneLength: 10 },
    { countryName: "Armenia", phoneCode: "+374", shortName: "AM", phoneLength: 8 },
    { countryName: "Australia", phoneCode: "+61", shortName: "AU", phoneLength: 9 },
    { countryName: "Austria", phoneCode: "+43", shortName: "AT", phoneLength: 9 },
    { countryName: "Azerbaijan", phoneCode: "+994", shortName: "AZ", phoneLength: 9 },
    { countryName: "Bahamas", phoneCode: "+1-242", shortName: "BS", phoneLength: 7 },
    { countryName: "Bahrain", phoneCode: "+973", shortName: "BH", phoneLength: 8 },
    { countryName: "Bangladesh", phoneCode: "+880", shortName: "BD", phoneLength: 10 },
    { countryName: "Barbados", phoneCode: "+1-246", shortName: "BB", phoneLength: 7 },
    { countryName: "Belarus", phoneCode: "+375", shortName: "BY", phoneLength: 9 },
    { countryName: "Belgium", phoneCode: "+32", shortName: "BE", phoneLength: 9 },
    { countryName: "Belize", phoneCode: "+501", shortName: "BZ", phoneLength: 7 },
    { countryName: "Benin", phoneCode: "+229", shortName: "BJ", phoneLength: 8 },
    { countryName: "Bhutan", phoneCode: "+975", shortName: "BT", phoneLength: 8 },
    { countryName: "Bolivia", phoneCode: "+591", shortName: "BO", phoneLength: 8 },
    { countryName: "Bosnia and Herzegovina", phoneCode: "+387", shortName: "BA", phoneLength: 8 },
    { countryName: "Botswana", phoneCode: "+267", shortName: "BW", phoneLength: 8 },
    { countryName: "Brazil", phoneCode: "+55", shortName: "BR", phoneLength: 11 },
    { countryName: "Brunei", phoneCode: "+673", shortName: "BN", phoneLength: 7 },
    { countryName: "Bulgaria", phoneCode: "+359", shortName: "BG", phoneLength: 9 },
    { countryName: "Burkina Faso", phoneCode: "+226", shortName: "BF", phoneLength: 8 },
    { countryName: "Burundi", phoneCode: "+257", shortName: "BI", phoneLength: 8 },
    { countryName: "Cabo Verde", phoneCode: "+238", shortName: "CV", phoneLength: 7 },
    { countryName: "Cambodia", phoneCode: "+855", shortName: "KH", phoneLength: 9 },
    { countryName: "Cameroon", phoneCode: "+237", shortName: "CM", phoneLength: 8 },
    { countryName: "Canada", phoneCode: "+1", shortName: "CA", phoneLength: 10 },
    { countryName: "Central African Republic", phoneCode: "+236", shortName: "CF", phoneLength: 8 },
    { countryName: "Chad", phoneCode: "+235", shortName: "TD", phoneLength: 8 },
    { countryName: "Chile", phoneCode: "+56", shortName: "CL", phoneLength: 9 },
    { countryName: "China", phoneCode: "+86", shortName: "CN", phoneLength: 11 },
    { countryName: "Colombia", phoneCode: "+57", shortName: "CO", phoneLength: 10 },
    { countryName: "Comoros", phoneCode: "+269", shortName: "KM", phoneLength: 7 },
    { countryName: "Congo (Congo-Brazzaville)", phoneCode: "+242", shortName: "CG", phoneLength: 8 },
    { countryName: "Congo (Democratic Republic)", phoneCode: "+243", shortName: "CD", phoneLength: 9 },
    { countryName: "Costa Rica", phoneCode: "+506", shortName: "CR", phoneLength: 8 },
    { countryName: "Croatia", phoneCode: "+385", shortName: "HR", phoneLength: 9 },
    { countryName: "Cuba", phoneCode: "+53", shortName: "CU", phoneLength: 8 },
    { countryName: "Cyprus", phoneCode: "+357", shortName: "CY", phoneLength: 8 },
    { countryName: "Czech Republic", phoneCode: "+420", shortName: "CZ", phoneLength: 9 },
    { countryName: "Denmark", phoneCode: "+45", shortName: "DK", phoneLength: 8 },
    { countryName: "Djibouti", phoneCode: "+253", shortName: "DJ", phoneLength: 7 },
    { countryName: "Dominica", phoneCode: "+1-767", shortName: "DM", phoneLength: 7 },
    { countryName: "Dominican Republic", phoneCode: "+1-809", shortName: "DO", phoneLength: 10 },
    { countryName: "Ecuador", phoneCode: "+593", shortName: "EC", phoneLength: 9 },
    { countryName: "Egypt", phoneCode: "+20", shortName: "EG", phoneLength: 10 },
    { countryName: "El Salvador", phoneCode: "+503", shortName: "SV", phoneLength: 8 },
    { countryName: "Equatorial Guinea", phoneCode: "+240", shortName: "GQ", phoneLength: 8 },
    { countryName: "Eritrea", phoneCode: "+291", shortName: "ER", phoneLength: 7 },
    { countryName: "Estonia", phoneCode: "+372", shortName: "EE", phoneLength: 8 },
    { countryName: "Eswatini", phoneCode: "+268", shortName: "SZ", phoneLength: 9 },
    { countryName: "Ethiopia", phoneCode: "+251", shortName: "ET", phoneLength: 9 },
    { countryName: "Fiji", phoneCode: "+679", shortName: "FJ", phoneLength: 7 },
    { countryName: "Finland", phoneCode: "+358", shortName: "FI", phoneLength: 9 },
    { countryName: "France", phoneCode: "+33", shortName: "FR", phoneLength: 10 },
    { countryName: "Gabon", phoneCode: "+241", shortName: "GA", phoneLength: 8 },
    { countryName: "Gambia", phoneCode: "+220", shortName: "GM", phoneLength: 7 },
    { countryName: "Georgia", phoneCode: "+995", shortName: "GE", phoneLength: 9 },
    { countryName: "Germany", phoneCode: "+49", shortName: "DE", phoneLength: 11 },
    { countryName: "Ghana", phoneCode: "+233", shortName: "GH", phoneLength: 9 },
    { countryName: "Greece", phoneCode: "+30", shortName: "GR", phoneLength: 10 },
    { countryName: "Grenada", phoneCode: "+1-473", shortName: "GD", phoneLength: 7 },
    { countryName: "Guatemala", phoneCode: "+502", shortName: "GT", phoneLength: 8 },
    { countryName: "Guinea", phoneCode: "+224", shortName: "GN", phoneLength: 9 },
    { countryName: "Guinea-Bissau", phoneCode: "+245", shortName: "GW", phoneLength: 8 },
    { countryName: "Guyana", phoneCode: "+592", shortName: "GY", phoneLength: 7 },
    { countryName: "Haiti", phoneCode: "+509", shortName: "HT", phoneLength: 8 },
    { countryName: "Honduras", phoneCode: "+504", shortName: "HN", phoneLength: 8 },
    { countryName: "Hungary", phoneCode: "+36", shortName: "HU", phoneLength: 9 },
    { countryName: "Iceland", phoneCode: "+354", shortName: "IS", phoneLength: 7 },
    { countryName: "India", phoneCode: "+91", shortName: "IN", phoneLength: 10 },
    { countryName: "Indonesia", phoneCode: "+62", shortName: "ID", phoneLength: 10 },
    { countryName: "Iran", phoneCode: "+98", shortName: "IR", phoneLength: 10 },
    { countryName: "Iraq", phoneCode: "+964", shortName: "IQ", phoneLength: 9 },
    { countryName: "Ireland", phoneCode: "+353", shortName: "IE", phoneLength: 9 },
    { countryName: "Israel", phoneCode: "+972", shortName: "IL", phoneLength: 9 },
    { countryName: "Italy", phoneCode: "+39", shortName: "IT", phoneLength: 10 },
    { countryName: "Jamaica", phoneCode: "+1-876", shortName: "JM", phoneLength: 7 },
    { countryName: "Japan", phoneCode: "+81", shortName: "JP", phoneLength: 10 },
    { countryName: "Jordan", phoneCode: "+962", shortName: "JO", phoneLength: 9 },
    { countryName: "Kazakhstan", phoneCode: "+7", shortName: "KZ", phoneLength: 10 },
    { countryName: "Kenya", phoneCode: "+254", shortName: "KE", phoneLength: 9 },
    { countryName: "Kiribati", phoneCode: "+686", shortName: "KI", phoneLength: 7 },
    { countryName: "Korea, North", phoneCode: "+850", shortName: "KP", phoneLength: 9 },
    { countryName: "Korea, South", phoneCode: "+82", shortName: "KR", phoneLength: 9 },
    { countryName: "Kuwait", phoneCode: "+965", shortName: "KW", phoneLength: 8 },
    { countryName: "Kyrgyzstan", phoneCode: "+996", shortName: "KG", phoneLength: 9 },
    { countryName: "Laos", phoneCode: "+856", shortName: "LA", phoneLength: 8 },
    { countryName: "Latvia", phoneCode: "+371", shortName: "LV", phoneLength: 8 },
    { countryName: "Lebanon", phoneCode: "+961", shortName: "LB", phoneLength: 8 },
    { countryName: "Lesotho", phoneCode: "+266", shortName: "LS", phoneLength: 8 },
    { countryName: "Liberia", phoneCode: "+231", shortName: "LR", phoneLength: 8 },
    { countryName: "Libya", phoneCode: "+218", shortName: "LY", phoneLength: 9 },
    { countryName: "Liechtenstein", phoneCode: "+423", shortName: "LI", phoneLength: 7 },
    { countryName: "Lithuania", phoneCode: "+370", shortName: "LT", phoneLength: 8 },
    { countryName: "Luxembourg", phoneCode: "+352", shortName: "LU", phoneLength: 9 },
    { countryName: "Madagascar", phoneCode: "+261", shortName: "MG", phoneLength: 9 },
    { countryName: "Malawi", phoneCode: "+265", shortName: "MW", phoneLength: 9 },
    { countryName: "Malaysia", phoneCode: "+60", shortName: "MY", phoneLength: 9 },
    { countryName: "Maldives", phoneCode: "+960", shortName: "MV", phoneLength: 7 },
    { countryName: "Mali", phoneCode: "+223", shortName: "ML", phoneLength: 8 },
    { countryName: "Malta", phoneCode: "+356", shortName: "MT", phoneLength: 8 },
    { countryName: "Marshall Islands", phoneCode: "+692", shortName: "MH", phoneLength: 7 },
    { countryName: "Mauritania", phoneCode: "+222", shortName: "MR", phoneLength: 9 },
    { countryName: "Mauritius", phoneCode: "+230", shortName: "MU", phoneLength: 8 },
    { countryName: "Mexico", phoneCode: "+52", shortName: "MX", phoneLength: 10 },
    { countryName: "Micronesia", phoneCode: "+691", shortName: "FM", phoneLength: 7 },
    { countryName: "Moldova", phoneCode: "+373", shortName: "MD", phoneLength: 8 },
    { countryName: "Monaco", phoneCode: "+377", shortName: "MC", phoneLength: 8 },
    { countryName: "Mongolia", phoneCode: "+976", shortName: "MN", phoneLength: 8 },
    { countryName: "Montenegro", phoneCode: "+382", shortName: "ME", phoneLength: 8 },
    { countryName: "Morocco", phoneCode: "+212", shortName: "MA", phoneLength: 9 },
    { countryName: "Mozambique", phoneCode: "+258", shortName: "MZ", phoneLength: 9 },
    { countryName: "Myanmar", phoneCode: "+95", shortName: "MM", phoneLength: 9 },
    { countryName: "Namibia", phoneCode: "+264", shortName: "NA", phoneLength: 8 },
    { countryName: "Nauru", phoneCode: "+674", shortName: "NR", phoneLength: 7 },
    { countryName: "Nepal", phoneCode: "+977", shortName: "NP", phoneLength: 10 },
    { countryName: "Netherlands", phoneCode: "+31", shortName: "NL", phoneLength: 9 },
    { countryName: "New Zealand", phoneCode: "+64", shortName: "NZ", phoneLength: 9 },
    { countryName: "Nicaragua", phoneCode: "+505", shortName: "NI", phoneLength: 8 },
    { countryName: "Niger", phoneCode: "+227", shortName: "NE", phoneLength: 8 },
    { countryName: "Nigeria", phoneCode: "+234", shortName: "NG", phoneLength: 10 },
    { countryName: "North Macedonia", phoneCode: "+389", shortName: "MK", phoneLength: 9 },
    { countryName: "Norway", phoneCode: "+47", shortName: "NO", phoneLength: 8 },
    { countryName: "Oman", phoneCode: "+968", shortName: "OM", phoneLength: 8 },
    { countryName: "Pakistan", phoneCode: "+92", shortName: "PK", phoneLength: 10 },
    { countryName: "Palau", phoneCode: "+680", shortName: "PW", phoneLength: 7 },
    { countryName: "Panama", phoneCode: "+507", shortName: "PA", phoneLength: 8 },
    { countryName: "Papua New Guinea", phoneCode: "+675", shortName: "PG", phoneLength: 8 },
    { countryName: "Paraguay", phoneCode: "+595", shortName: "PY", phoneLength: 9 },
    { countryName: "Peru", phoneCode: "+51", shortName: "PE", phoneLength: 9 },
    { countryName: "Philippines", phoneCode: "+63", shortName: "PH", phoneLength: 10 },
    { countryName: "Poland", phoneCode: "+48", shortName: "PL", phoneLength: 9 },
    { countryName: "Portugal", phoneCode: "+351", shortName: "PT", phoneLength: 9 },
    { countryName: "Qatar", phoneCode: "+974", shortName: "QA", phoneLength: 8 },
    { countryName: "Romania", phoneCode: "+40", shortName: "RO", phoneLength: 10 },
    { countryName: "Russia", phoneCode: "+7", shortName: "RU", phoneLength: 10 },
    { countryName: "Rwanda", phoneCode: "+250", shortName: "RW", phoneLength: 9 },
    { countryName: "Saint Kitts and Nevis", phoneCode: "+1-869", shortName: "KN", phoneLength: 7 },
    { countryName: "Saint Lucia", phoneCode: "+1-758", shortName: "LC", phoneLength: 7 },
    { countryName: "Saint Vincent and the Grenadines", phoneCode: "+1-784", shortName: "VC", phoneLength: 7 },
    { countryName: "Samoa", phoneCode: "+685", shortName: "WS", phoneLength: 7 },
    { countryName: "San Marino", phoneCode: "+378", shortName: "SM", phoneLength: 7 },
    { countryName: "Sao Tome and Principe", phoneCode: "+239", shortName: "ST", phoneLength: 8 },
    { countryName: "Saudi Arabia", phoneCode: "+966", shortName: "SA", phoneLength: 9 },
    { countryName: "Senegal", phoneCode: "+221", shortName: "SN", phoneLength: 9 },
    { countryName: "Serbia", phoneCode: "+381", shortName: "RS", phoneLength: 9 },
    { countryName: "Seychelles", phoneCode: "+248", shortName: "SC", phoneLength: 7 },
    { countryName: "Sierra Leone", phoneCode: "+232", shortName: "SL", phoneLength: 8 },
    { countryName: "Singapore", phoneCode: "+65", shortName: "SG", phoneLength: 8 },
    { countryName: "Slovakia", phoneCode: "+421", shortName: "SK", phoneLength: 9 },
    { countryName: "Slovenia", phoneCode: "+386", shortName: "SI", phoneLength: 8 },
    { countryName: "Solomon Islands", phoneCode: "+677", shortName: "SB", phoneLength: 7 },
    { countryName: "Somalia", phoneCode: "+252", shortName: "SO", phoneLength: 8 },
    { countryName: "South Africa", phoneCode: "+27", shortName: "ZA", phoneLength: 9 },
    { countryName: "South Sudan", phoneCode: "+211", shortName: "SS", phoneLength: 9 },
    { countryName: "Spain", phoneCode: "+34", shortName: "ES", phoneLength: 9 },
    { countryName: "Sri Lanka", phoneCode: "+94", shortName: "LK", phoneLength: 9 },
    { countryName: "Sudan", phoneCode: "+249", shortName: "SD", phoneLength: 9 },
    { countryName: "Suriname", phoneCode: "+597", shortName: "SR", phoneLength: 8 },
    { countryName: "Sweden", phoneCode: "+46", shortName: "SE", phoneLength: 9 },
    { countryName: "Switzerland", phoneCode: "+41", shortName: "CH", phoneLength: 9 },
    { countryName: "Syria", phoneCode: "+963", shortName: "SY", phoneLength: 9 },
    { countryName: "Taiwan", phoneCode: "+886", shortName: "TW", phoneLength: 9 },
    { countryName: "Tajikistan", phoneCode: "+992", shortName: "TJ", phoneLength: 9 },
    { countryName: "Tanzania", phoneCode: "+255", shortName: "TZ", phoneLength: 9 },
    { countryName: "Thailand", phoneCode: "+66", shortName: "TH", phoneLength: 9 },
    { countryName: "Timor-Leste", phoneCode: "+670", shortName: "TL", phoneLength: 7 },
    { countryName: "Togo", phoneCode: "+228", shortName: "TG", phoneLength: 8 },
    { countryName: "Tonga", phoneCode: "+676", shortName: "TO", phoneLength: 7 },
    { countryName: "Trinidad and Tobago", phoneCode: "+1-868", shortName: "TT", phoneLength: 7 },
    { countryName: "Tunisia", phoneCode: "+216", shortName: "TN", phoneLength: 8 },
    { countryName: "Turkey", phoneCode: "+90", shortName: "TR", phoneLength: 10 },
    { countryName: "Turkmenistan", phoneCode: "+993", shortName: "TM", phoneLength: 9 },
    { countryName: "Tuvalu", phoneCode: "+688", shortName: "TV", phoneLength: 7 },
    { countryName: "Uganda", phoneCode: "+256", shortName: "UG", phoneLength: 9 },
    { countryName: "Ukraine", phoneCode: "+380", shortName: "UA", phoneLength: 9 },
    { countryName: "United Arab Emirates", phoneCode: "+971", shortName: "AE", phoneLength: 9 },
    { countryName: "United Kingdom", phoneCode: "+44", shortName: "GB", phoneLength: 10 },
    { countryName: "United States", phoneCode: "+1", shortName: "US", phoneLength: 10 },
    { countryName: "Uruguay", phoneCode: "+598", shortName: "UY", phoneLength: 9 },
    { countryName: "Uzbekistan", phoneCode: "+998", shortName: "UZ", phoneLength: 9 },
    { countryName: "Vanuatu", phoneCode: "+678", shortName: "VU", phoneLength: 7 },
    { countryName: "Vatican City", phoneCode: "+379", shortName: "VA", phoneLength: 7 },
    { countryName: "Venezuela", phoneCode: "+58", shortName: "VE", phoneLength: 10 },
    { countryName: "Vietnam", phoneCode: "+84", shortName: "VN", phoneLength: 10 },
    { countryName: "Yemen", phoneCode: "+967", shortName: "YE", phoneLength: 9 },
    { countryName: "Zambia", phoneCode: "+260", shortName: "ZM", phoneLength: 9 },
    { countryName: "Zimbabwe", phoneCode: "+263", shortName: "ZW", phoneLength: 9 }
];


constructor(
  private _http: HttpClient
) {}



getCountries(query?: string): Observable<any> {
  let param = query ? `&${query}` : ''
  return this._http.get(`${environment.apiUrl}countries/?active=true${param}`)

}


  
}


export interface ICountries {
  countryName: string;
  shortName: string;
  phoneCode: string;
  phoneLength: number
}